import { PRECISION } from "../../precision";

const ETA = ({ selectedDriver }) => {
  if (!selectedDriver?.progress) return null;
  const { remainingDistance, remainingEtaSecs } = selectedDriver.progress;
  return (
    <div
      style={{
        background: "#d3d5d7ff",
        padding: "8px 12px",
        marginBottom: "12px",
        borderRadius: "6px",
        fontSize: "13px",
        borderLeft: "4px solid #1A73E8",
      }}
    >
      <b>ETA:</b> {Math.round(remainingEtaSecs / 60)} min &nbsp;|&nbsp;
      <b>Distance:</b> {(remainingDistance / 1000).toFixed(PRECISION)} km
    </div>
  );
};

export default ETA;
